<div
  dataSelector="sidenav"
  class="sidenav-container h-100"
  [ngClass]="{ collapsed: collapsed, collapsing: collapsing }"
  [hidden]="!getUserName()"
>
  <div
    class="sidenav h-100 d-flex flex-column"
    [ngClass]="{ collapsed: collapsed, collapsing: collapsing, menuOpen: menuOpen }"
    (mouseenter)="onSidenavMouseEnter()"
    (mouseleave)="onSidenavMouseLeave()"
  >
    <div class="sidenav-header d-flex justify-content-between align-items-center px-3">
      <span class="d-flex">
        <anduin-icon name="aiwyn-mark" height="24" width="24" />
        <span class="title d-flex ms-1 align-items-center">Aiwyn</span>
      </span>
      <button class="expand-btn d-flex align-items-center justify-content-center" (click)="toggleSidebar()">
        <anduin-icon *ngIf="!collapsed" name="chevrons-left" height="16" width="16" />
        <anduin-icon *ngIf="collapsed" name="chevrons-right" height="16" width="16" />
      </button>
    </div>
    <div class="sidenav-options flex-grow-1">
      <ng-container *ngFor="let option of sidenavOptions">
        <ng-container *ngIf="option.enabled">
          <ng-container [ngSwitch]="option.type">
            <app-sidenav-link-option *ngSwitchCase="'link'" [collapsed]="collapsed" [option]="option" />
            <app-sidenav-menu-option *ngSwitchCase="'menu'" [collapsed]="collapsed" [option]="option" />
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div class="sidenav-footer">
      @if (configService.shareFeedbackEnabled) {
        <ng-container *ngTemplateOutlet="shareFeedbackButton" />
      }
      <ng-container *ngFor="let option of sidenavFooterOptions">
        <ng-container *ngIf="option.enabled">
          <ng-container [ngSwitch]="option.type">
            <app-sidenav-link-option *ngSwitchCase="'link'" [collapsed]="collapsed" [option]="option" />
            <app-sidenav-menu-option *ngSwitchCase="'menu'" [collapsed]="collapsed" [option]="option" />
          </ng-container>
        </ng-container>
      </ng-container>
      <div class="app-info d-flex align-items-center justify-content-between">
        <span class="collapsed-version">{{ version$ | async }}</span>
        <span class="full-version">Aiwyn {{ version$ | async }}</span>
        <a *ngIf="false" href="#" target="_blank">Terms & Conditions</a>
      </div>
    </div>
  </div>
</div>

<ng-template #shareFeedbackButton>
  @if (collapsed && !isHovering && !menuOpen) {
    <button [dataSelector]="'share-feedback-button'" class="share-feedback-button is-collapsed" andButton>
      <anduin-icon name="megaphone" [height]="16" [width]="16" namespace="phosphor" />
    </button>
  } @else {
    <button [dataSelector]="'share-feedback-button'" class="share-feedback-button" andButton>
      <anduin-icon name="megaphone" class="me-2" [height]="16" [width]="16" namespace="phosphor" />
      Share Feedback
    </button>
  }
</ng-template>
